const svg4everybody = require('svg4everybody');

svg4everybody();

const polyfill = require('./helpers/polyfill.js');
window.jQuery = require('jquery');

window.$ = jQuery;
window.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;

polyfill();

/**
 * Toolkit JavaScript
 */

/* helpers */

require('./helpers/networking.js');
const floatingLabels = require('./helpers/floatingLabels.js');
const videoPlaceholder = require('./helpers/videoPlaceholder.js');
const autoFill = require('./helpers/autoFill.js');
const nestedLink = require('./helpers/nestedLink.js');
const preventSubmit = require('./helpers/preventSubmit.js');
const restrictLength = require('./helpers/restrictLength.js');

const navbar = require('./components/navbar.js');
const tabs = require('./components/tabs.js');
const showHideAndToggle = require('./components/showHideAndToggle.js');
const toggleActive = require('./components/toggleActive.js');
const paCountdown = require('./components/paCountdown.js');
const newsletterSignup = require('./components/newsletterSignup.js');
const gallery = require('./components/gallery.js');
const slider = require('./components/slider.js');
const coupon = require('./components/coupon.js');
const accordion = require('./components/accordion.js');
const copypaste = require('./components/copypaste.js');
const validation = require('./components/form-validation.js');
const limitedTag = require('./components/limitedTag.js');
const productDetail = require('./components/product-detail.js');
const infiniteScroll = require('./components/infinite-scroll.js');
const sportlink = require('./components/sportlink.js');
const selectChange = require('./components/selectChange.js');
const shoppingCardModal = require('./components/shopping-cart-modal.js');
const ctaClick = require('./components/ctaClick.js');
const submitForm = require('./components/submit-form.js');
const submitFormOnChange = require('./components/submit-form-on-change.js');
const sticky = require('./components/sticky.js');
const scrollto = require('./components/scrollto.js');
const table = require('./components/table.js');
const contactForm = require('./components/contact-form.js');
const factsAndFigures = require('./components/facts-and-figures.js');
import carousel from './components/carousel.js';
const jerseyEmbellishment = require('./components/jersey-embellishment.js');

$(() => {
	showHideAndToggle();
	paCountdown();
	floatingLabels();
	videoPlaceholder();
	autoFill();
	nestedLink();
	preventSubmit();
	restrictLength();

	navbar();
	tabs();
	toggleActive();
	newsletterSignup();
	gallery();
	slider();
	coupon();
	accordion();
	copypaste();
	validation();
	limitedTag();
	productDetail();
	infiniteScroll();
	sportlink();
	selectChange();
	shoppingCardModal();
	ctaClick();
	submitForm();
	submitFormOnChange();
	sticky();
	scrollto();
	table();
	contactForm();
	factsAndFigures();
	carousel.init();

	// embellishment stuff

	document.querySelectorAll('.js-270viewer-embellish').forEach($el => {
		TSDViewer.create($el, {
			onLoadComplete: () => {
				jerseyEmbellishment($el)
			}
		})
	})
});


